
import './App.css';


import IndexPrincipal from './Index Principal';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <IndexPrincipal />
      </header>
    </div>
  );
}

export default App;

